module.exports = __webpack_public_path__ + "static/media/linkedin-phone.30542509.png";